import React from "react";
import { Check, X } from "lucide-react";

const FOR_LIST = [
  "Established or emerging coaches",
  "Consultants and business advisors",
  "Agency owners scaling their brand",
  "Trainers and educators",
  "Business mentors",
  "Professional service providers",
  "Founders selling high-value services",
  "Experts ready to monetise their knowledge",
];

const NOT_FOR_LIST = [
  "People searching for overnight income",
  "People unwilling to implement what they learn",
  "People expecting AI to replace all real effort",
  "People only looking for free tools or generic motivation",
  "Anyone hoping for a shortcut without doing the work",
];

export default function WhoForNotFor() {
  return (
    <section className="relative z-10 px-4 py-10 md:py-14">
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-[#C4FF3D] uppercase tracking-[0.28em] text-[11px] md:text-xs font-bold mb-3">
          Before You Register
        </p>
        <h2 className="display-font text-center text-3xl md:text-5xl font-extrabold leading-tight mb-12">
          <span className="text-white">Let's Be</span>{" "}
          <span className="lime-box">Honest About Fit.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* For */}
          <div className="rounded-3xl border border-[rgba(196,255,61,0.32)] bg-[#0e1410] p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-[rgba(196,255,61,0.15)] border border-[rgba(196,255,61,0.4)] flex items-center justify-center">
                <Check className="w-5 h-5 text-[#C4FF3D]" strokeWidth={3} />
              </div>
              <h3 className="text-white text-xl md:text-2xl font-bold">This Is For You If You Are…</h3>
            </div>
            <ul className="space-y-3">
              {FOR_LIST.map((item) => (
                <li key={item} className="flex items-start gap-3 text-white/85">
                  <Check className="w-5 h-5 text-[#C4FF3D] shrink-0 mt-0.5" strokeWidth={3} />
                  <span className="leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Not For */}
          <div className="rounded-3xl border border-white/10 bg-[#0e1410]/70 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center">
                <X className="w-5 h-5 text-red-400" strokeWidth={3} />
              </div>
              <h3 className="text-white text-xl md:text-2xl font-bold">This Is Not For…</h3>
            </div>
            <ul className="space-y-3">
              {NOT_FOR_LIST.map((item) => (
                <li key={item} className="flex items-start gap-3 text-white/70">
                  <X className="w-5 h-5 text-red-400/80 shrink-0 mt-0.5" strokeWidth={3} />
                  <span className="leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
            <p className="text-white/45 text-xs md:text-sm mt-6 italic border-t border-white/10 pt-4">
              We'd genuinely rather you skip this workshop than register for the wrong reason.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
